<script setup lang="ts">
import logoPinwheel from "~/assets/svg/surekleanz-icon-blue.svg";

defineOptions({
  name: "LoadingSpinner",
});

withDefaults(
  defineProps<{
    containerClasses?: string;
    imgClasses?: string;
  }>(),
  {
    containerClasses:
      "w-screen h-screen fixed inset-0 bg-[rgba(255,255,255,0)] flex flex-col items-center justify-center",
    imgClasses: "w-32 h-10",
  },
);
</script>
<template>
  <div :class="containerClasses">
    <img :src="logoPinwheel" class="animate-spin" :class="imgClasses" :alt="$t('alt.spinner')" />
    <slot />
  </div>
</template>
